import { useEffect, useRef, useState } from 'react';
import { HappyCallTemplate } from 'type/type';
import { getHappyCallTemplateAll } from 'api/api';
import Pagenation from 'components/common/Pagenation';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CommonTable, CommonTableWrap, FilterContentContainer } from 'pages/Layout';
import { PrimaryButton } from 'components/common/Button';

interface SearchInputType {
  type: string,
  page?: number,
};

function HappyCallTemplateList() {
  const isFirstRender = useRef(true);
  const [searchParams, setSearchParams] = useSearchParams();
  // 필터obj
  const [searchObj, setSearchObj] = useState<SearchInputType>({
    type: searchParams.get("type") || "",
    page: searchParams.get("page") ? Number(searchParams.get("page")) : undefined,
  });
  const navigate = useNavigate();
  const [happyCallTemplateArr, setHappyCallTemplateArr] = useState<HappyCallTemplate[]>([]);
  // 페이지네이션
  const buttonPerPage = 10; // 보여줄 페이지네이션 버튼 수
  const [page, setPage] = useState(searchObj.page || 1); // 현재 페이지
  const [limit] = useState(10); // 보여줄 게시물 개수
  const [totalCount, setTotalCount] = useState(-1);
  const numPages = Math.ceil(totalCount / limit); // 총 페이지 수
  const [startButtonNum, setStartButtonNum] = useState(1); // 버튼 시작 숫자

  // 페이지네이션 버튼 클릭 시
  const isClickButton = (str:string) => {
    if (str === 'prev') handlePrevPage();
    else handleNextPage();
  };

  // 이전페이지 이동(buttonPerPage만큼 -)
  const handlePrevPage = () => {
    const prevPage = Math.max(startButtonNum - buttonPerPage, 1);
    setStartButtonNum(prevPage);
    setPage(prevPage);
  };

  // 다음페이지 이동(buttonPerPage만큼 +)
  const handleNextPage = () => {
    const nextPage = Math.min(startButtonNum + buttonPerPage, numPages);
    setStartButtonNum(nextPage);
    setPage(nextPage);
  };

  const searchHandle = () => {
    page === 1 ? getHappyCallTemplate(page, limit) : setPage(1);
  }

  const getHappyCallTemplate = async (page: number, limit: number) => {
    const { type } = searchObj;
    const param: Record<string, string> = { type };
    const happyCallTemplateRes = await getHappyCallTemplateAll(page, limit, param);
    if (happyCallTemplateRes.code === 200) {
      setHappyCallTemplateArr(happyCallTemplateRes.data);
      setTotalCount(happyCallTemplateRes.total_count);
    }
    setSearchParams({ type, page : String(page) });
  };
  
  // 검색 type 변경
  const handleSearchType = (type: string) => {
    setSearchObj(prev => ({...prev, type }));
  };
  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false;
    //   const hasParams = searchParams.toString() !== "";
    //   if (!hasParams) return; // ❌ 파라미터 없으면 첫 렌더 스킵
    // }
    getHappyCallTemplate(page, limit); // ✅ 이후에는 무조건 실행
  }, [page, limit]);
  return (
    <>
      <FilterContentContainer>
        <div className='flex-row'>
          <label>검색</label>
          <div>
            <select name="search_type" onChange={(e) => handleSearchType(e.target.value)} value={searchObj.type} >
              <option value="">전체 분류</option>
              <option value="기본">기본</option>
              <option value="내부 이벤트 없음">내부 이벤트 없음</option>
              <option value="외부 이벤트 없음">외부 이벤트 없음</option>
              <option value="이벤트 발생">이벤트 발생</option>
              <option value="전체시간 대기반">전체시간 대기반</option>
              <option value="잠금 보안 이벤트 없음">잠금 보안 이벤트 없음</option>
            </select>
          </div>
        </div>
        <PrimaryButton type="button" onClick={searchHandle}>조회</PrimaryButton>
        <div className='flex-row btn-wrap'>
          <PrimaryButton type="button" onClick={() => navigate('/admin/happy-call/template-process')}>등록</PrimaryButton>
        </div>
      </FilterContentContainer>
      <div>
        검색 결과: <span style={{ fontWeight: "600" }}>{totalCount < 0 ? 0 : totalCount}</span>건
      </div>
      <CommonTableWrap>
        <CommonTable>
          <thead>
            <tr>
              <th>No</th>
              <th>분류</th>
              <th>메시지</th>
            </tr>
          </thead>
          <tbody>
              {totalCount === 0 ?
                <tr>
                  <td colSpan={3}>검색결과가 없습니다.</td>
                </tr>
                :
                happyCallTemplateArr.map((happyCallTemplate, idx) => 
                  <tr key={`happyCallTemplate_${idx}`} onClick={() => navigate(`/admin/happy-call/template-process/${happyCallTemplate.idx}`)}>
                    <td>{(page - 1) * 10 + idx + 1}</td>
                    <td>{happyCallTemplate.type}</td>
                    <td>{happyCallTemplate.message}</td>
                  </tr>
                )
              }
          </tbody>
        </CommonTable>
      </CommonTableWrap>
      <Pagenation
        totalCount={totalCount}
        total={numPages}
        limit={limit}
        page={page}
        setPage={setPage}
        startButtonNum={startButtonNum}
        setClickButton={isClickButton}
      />
    </>
  );
}

export default HappyCallTemplateList;